import React from "react";

const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload || !payload.length) return null;

    const value = payload[0].payload.CARR * 1000;
    const currentCarr = payload[payload.findIndex((obj) => obj.dataKey === "Total Bookings")].value;
    const yoyGrowth = payload[1].value;

    const isExistingCarr =
        payload[0].payload.name === "Final" || payload[0].payload.name === "Existing";

    return (
        <div style={{ backgroundColor: "#fff", border: "1px solid #ccc", padding: 10 }}>
            <p className="font-bold">{label}</p>
            <p
                className="font-bold"
                style={{ color: "#156082" }}
            >{`Total Bookings: $${currentCarr.toLocaleString()}`}</p>
            {/* <p style={{ color: '#156082' }}>{JSON.stringify(Object.keys(payload[0]))}</p>
        <p style={{ color: '#156082' }}>{JSON.stringify(payload[0].fill)}</p> */}
            {payload.map((item, index) => (
                <p key={index} style={{ color: item.fill }}>
                    {`${item.name || item.dataKey}: $${item.value?.toLocaleString()}`}
                </p>
            ))}
        </div>
    );
};

export default CustomTooltip;
